import * as React from 'react'
import * as PropTypes from 'prop-types'
import styled from 'styled-components'

import Icon from '../../../../components/ui/Icon/Icon'

const SubjectItems = styled.li`
  list-style: none;
  border-bottom: 1px solid #cecece;
`

const SubjectWrapper = styled.div`
  cursor: pointer;
  padding: 0.5rem 1rem;
  min-height: 54px;

  display: flex;
  flex-direction: row;

  &:hover span {
    /* font-weight: var(--font-weight-bold); */
    cursor: pointer;
  }
  align-items: center;

  svg {
    color: var(--color-primary);
  }
`

const AccordionIcon = styled.div`
  transform: rotate(${props => (props.itemDisplay ? '-90deg' : '90deg')});
  transition-property: transform;
  transition-duration: var(--animation-duration);
  transition-timing-function: var(--animation-easing);
`

const ListWrapper = styled.ul`
  position: relative;
  list-style: none;
  padding: 0 20px;
  background: #f7fafa;
  border-top: ${props => (props.display ? '1px solid #cecece' : 'none')};
  overflow: hidden;
  transition-property: max-height;
  transition-duration: var(--animation-duration);
  transition-timing-function: var(--animation-easing);
`

const ListItems = styled.li`
  cursor: pointer;
  list-style: none;
  min-height: 54px;
  border-bottom: 1px solid #cecece;

  display: flex;
  flex-direction: row;

  &:hover span {
    /* font-weight: var(--font-weight-bold); */
    cursor: pointer;
  }
  align-items: center;

  svg {
    color: var(--color-primary);
  }

  &:last-child {
    border: none;
  }
`

const Label = styled.span`
  flex-grow: 1;
  padding-left: 5px;
  margin-right: 1rem;
`

function FrequentlyAskedItems(props) {
  const [setHeight, setHeightState] = React.useState('0px')
  const content = React.useRef(null)

  const { showDetailPage, showItems, data = {}, index, expand } = props

  const { id, name, displayItems, items = [] } = data

  const toggleAccordion = (toggledItems, itemIndex) => {
    setHeightState(toggledItems ? '0px' : `${content.current.scrollHeight}px`)

    showItems(itemIndex)
  }

  React.useEffect(() => {
    if (expand) {
      setHeightState('unset')
      showItems(index)
    }
  }, [expand, index, showItems])

  return (
    <SubjectItems key={id}>
      <SubjectWrapper onClick={() => toggleAccordion(displayItems, index)}>
        <Label>{name}</Label>
        <AccordionIcon itemDisplay={displayItems}>
          <Icon name="slide-right" />
        </AccordionIcon>
      </SubjectWrapper>
      <ListWrapper
        ref={content}
        display={displayItems}
        style={{ maxHeight: setHeight }}
      >
        {items.map(item => (
          <ListItems key={item.id} onClick={() => showDetailPage(item)}>
            <Label>{item.question}</Label>
            <Icon name="slide-right" />
          </ListItems>
        ))}
      </ListWrapper>
    </SubjectItems>
  )
}

FrequentlyAskedItems.defaultProps = {
  primaryInfo: {},
}

FrequentlyAskedItems.propTypes = {
  primaryInfo: PropTypes.object,
}

export default FrequentlyAskedItems
